
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_BASE_URL || '/api/v1';

export const getWebinarByAccount = async (accountId) => {
  try {
    const response = await axios.get(`${API_URL}/webinars?account_id=${accountId}`);
    console.log('Webinar API Response:', response.data); // For debugging
    
    // Backend returns {data: webinars} - get the first webinar from the data array
    const webinars = response.data.data || [];
    const webinarData = Array.isArray(webinars) && webinars.length > 0 ? webinars[0] : null;
    
    console.log('Processed Webinar Data:', webinarData); // For debugging
    return webinarData;
  } catch (error) {
    console.error('Error fetching webinar:', error);
    return null;
  }
};